import { makeObservable, observable, action, computed } from 'mobx';
import { biohacker01 } from './biohacker01';
import { biohacker02 } from './biohacker02';
import { biohacker03 } from './biohacker03';


 export const allSampleData = {
     "biohacker01": biohacker01,
     "biohacker02": biohacker02,
     "biohacker03": biohacker03,
 }
